
import React from 'react';
import { FormFieldType } from '@/types/form';
import FieldWrapper from '../FieldWrapper';
import WorksheetSelector from './WorksheetSelector';
import OtherSubjectCheckbox from './OtherSubjectCheckbox';
import { useWorksheetSelection } from './useWorksheetSelection';
import DocumentLinkField from '../DocumentLinkField';
import { useTranslation } from 'react-i18next';

interface NextTopicWorksheetSearchFieldProps {
  element: FormFieldType;
}

export const NextTopicWorksheetSearchField: React.FC<NextTopicWorksheetSearchFieldProps> = ({ element }) => {
  const { t } = useTranslation();
  const {
    otherSubject,
    setSearchQuery,
    isLoading,
    handleSelectWorksheet,
    handleOtherSubjectChange,
    options,
    selectedOption,
    documentUrls
  } = useWorksheetSelection({
    element,
    otherSubjectField: 'next_topic_other_subject',
    subjectDataField: 'next_topic_subject_data',
    worksheetIdField: 'next_worksheet_id'
  });

  return (
    <FieldWrapper element={element}>
      <div className="space-y-4">
        <WorksheetSelector
          options={options}
          value={selectedOption}
          onChange={handleSelectWorksheet}
          onInputChange={setSearchQuery}
          isLoading={isLoading}
          disabled={otherSubject}
        />
        
        <OtherSubjectCheckbox
          id="next-topic-other-subject"
          checked={otherSubject}
          onChange={handleOtherSubjectChange}
        />
        
        {/* Display document links if available */}
        {documentUrls && documentUrls.length > 0 && (
          <div className="mt-4">
            <DocumentLinkField 
              element={{
                id: "next_document_links",
                type: "document_link",
                label: t('form.fields.nextTopicSheetLabel'),
                name: "next_document_links",
                description: t('form.fields.nextTopicSheetDesc')
              }} 
              documentUrls={documentUrls} 
            />
          </div>
        )}
      </div>
    </FieldWrapper>
  );
};

export default NextTopicWorksheetSearchField;
